import getApi from '../../api/apisauceConfig'
import { SpeechAudiogram } from '../../model/Audiometry'

export const updateSpeechAudiogram = (id: number, payload: Partial<SpeechAudiogram>) =>
  getApi().put<SpeechAudiogram>(`/audiometry/speech_audiograms/${id}`, payload)
